import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { UnidataTable } from '~/components';
import { t } from '~/helpers';
import { handleExportGeneric } from '~/helpers/exportReports';
import {
  deleteTanquesVirtual,
  findTanquesVirtual,
  recordFiltering,
} from '~/store/modules/tanquevirtual/actions';

import Form from './form';

function TanquesVirtualList() {
  const redux = useSelector((state) => state.tanquevirtual);

  const status = useMemo(
    () => [
      { label: 'L', value: t('s.geral.opcoes.liberado') },
      { label: 'B', value: t('s.geral.opcoes.bloqueado') },
      { label: 'C', value: t('s.geral.opcoes.cancelado') },
    ],
    []
  );

  const header = useMemo(
    () => [
      {
        id: 'idtanquevirtual',
        label: t('s.cadastro.tanquevirtual.idtanquevirtual'),
        filter: { type: 'text' },
      },

      {
        id: 'codigonomeposto',
        label: t('s.geral.postocomboio'),
        filter: { type: 'text' },
      },

      {
        id: 'nomeproduto',
        label: t('s.configuracao.tanquevirtual.nomeproduto'),
        filter: { type: 'text' },
      },

      {
        id: 'statustanquevirtual',
        label: t('s.cadastro.tanquevirtual.statustanquevirtual'),
        formatted: (value) => status.find((s) => s.label === value).value || '',
        filter: { type: 'select', options: status },
      },
    ],
    [status]
  );

  const fieldlist = [
    'idtanquevirtual',
    'codigonomeposto',
    'nomeproduto',
    'statustanquevirtual',
  ];

  const substituirHeader = {
    statustanquevirtual: t('s.cadastro.tanquevirtual.statustanquevirtual'),
    nomeproduto: t('s.configuracao.tanquevirtual.nomeproduto'),
    codigonomeposto: t('s.geral.postocomboio'),
    idtanquevirtual: t('s.cadastro.tanquevirtual.idtanquevirtual'),
  };

  return (
    <UnidataTable
      fixed
      redux={redux}
      header={header}
      read={recordFiltering}
      find={findTanquesVirtual}
      remove={deleteTanquesVirtual}
      form={Form}
      keys={['idtanquevirtual', 'idposto']}
      detach="idtanquevirtual"
      excel
      pdf
      onExport={(formato) =>
        handleExportGeneric({
          endpoint: 'tanquesvirtuais',
          formato,
          fields: fieldlist,
          redux,
          headers: substituirHeader,
          title: 'Relatório de Tanques Virtuais',
          ordination: redux.params.ordination,
          orderfield: redux.params.orderfield,
          substituirValores: {
            statustanquevirtual: {
              L: t('s.geral.opcoes.liberado'),
              B: t('s.geral.opcoes.bloqueado'),
              C: t('s.geral.opcoes.cancelado'),
            },
          },
        })
      }
    />
  );
}

export default TanquesVirtualList;
